export const MF_NAME = 'frontend-journal-app';

export const IS_PROD = import.meta.env.VITE_RUNTIME_IS_PROD
  ? Boolean(Number(import.meta.env.VITE_RUNTIME_IS_PROD))
  : false;
